import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/place.svg'


const _withScopeId = n => (_pushScopeId("data-v-082cd632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-info" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "info-detail book-date-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "예약일시", -1 /* HOISTED */))
const _hoisted_5 = { class: "info-content" }
const _hoisted_6 = { class: "info-detail line-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "예약노선", -1 /* HOISTED */))
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "line-route-name" }
const _hoisted_10 = { class: "info-detail departure-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "승차", -1 /* HOISTED */))
const _hoisted_12 = { class: "bus-stop-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "info-detail arrival-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "하차", -1 /* HOISTED */))
const _hoisted_16 = { class: "bus-stop-name" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString($props.bookDeteTime), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.useGetLineRouteName(
                $props.lineInfo?.lineTypeCode,
                $props.lineInfo?.routeName,
                $props.lineInfo?.lineNum
              )), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "info-content",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.lineInfo?.getOnStop.id)))
        }, [
          _createElementVNode("p", _hoisted_12, _toDisplayString($props.lineInfo?.getOnStop.name), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(`(${$props.lineInfo?.getOnStop.departureTime})`), 1 /* TEXT */),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", {
          class: "info-content",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.lineInfo?.getOffStop.id)))
        }, [
          _createElementVNode("p", _hoisted_16, _toDisplayString($props.lineInfo?.getOffStop.name), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(`(${$props.lineInfo?.getOffStop.arrivalTime})`), 1 /* TEXT */),
          _hoisted_17
        ])
      ])
    ])
  ]))
}